import store from '@/state/store'

export default [
    {
        path: '/login',
        name: 'login',
        component: () => import('../views/pages/account/login'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                if (store.getters['auth/loggedIn']) {
                    next({ name: 'home' })
                } else {
                    next()
                }
            },
        },
    },
    // {
    //     path: '/testing',
    //     name: 'testing',
    //     component: () => import('../views/pages/testing/testing'),
    //     meta: {
    //     },
    // },
    {
        path: '/forgot-password',
        name: 'Forgot-password',
        component: () => import('../views/pages/account/forgot-password'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                if (store.getters['auth/loggedIn']) {
                    next({ name: 'home' })
                } else {
                    next()
                }
            },
        },
    },
    {
        path: '/logout',
        name: 'logout',
        meta: {
            authRequired: true,
            async beforeResolve(routeTo, routeFrom, next) {
                await store.dispatch('auth/logout')

                const authRequiredOnPreviousRoute = routeFrom.matched.some(
                    (route) => route.push('/login')
                )
                next(authRequiredOnPreviousRoute ? { name: 'home' } : { ...routeFrom })
            },
        },
    },
    {
        path: '/reset-password',
        name: 'Reset password',
        component: () => import('../views/pages/account/create-password-forgot'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                next()
            },
        },
    },
    {
        path: '/first-time-password',
        name: 'Create-password',
        component: () => import('../views/pages/account/create-password'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                next()
            },
        },
    },
    {
        path: '/',
        name: 'home',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/product/productListing')
    },
    {
        path: '/password-reset',
        name: 'Password-reset-listing',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/passwordReset/passwordResetListing')
    },
    {
        path: '/profile',
        name: 'Profile',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/user/profile')
    },
    {
        path: '/user',
        name: 'User-listing',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/user/userListing')
    },
    {
        path: '/user/update',
        name: 'User-update',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/user/userUpdate')
    },
    {
        path: '/user/create',
        name: 'User-create',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/user/userCreate')
    },
    {
        path: '/configuration',
        name: 'Configuration-listing',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/configuration/configurationListing')
    },
    {
        path: '/configuration/update',
        name: 'Configuration-update',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/configuration/configurationUpdate')
    },
    {
        path: '/role',
        name: 'Role-listing',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/role/roleListing')
    },
    {
        path: '/role/update',
        name: 'Role-update',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/role/roleUpdate')
    },
    {
        path: '/role/create',
        name: 'Role-create',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/role/roleCreate')
    },
    {
        path: '/AI',
        name: 'AI-listing',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/ai/aiListing.vue')
    },
    {
        path: '/AI/create',
        name: 'AI-create',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/common/create.vue')
    },
    {
        path: '/AI/update',
        name: 'AI-update',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/common/update.vue')
    },
    {
        path: '/brand',
        name: 'Brand-listing',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/brand/brandListing.vue')
    },
    {
        path: '/brand/create',
        name: 'Brand-create',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/common/create.vue')
    },
    {
        path: '/brand/update',
        name: 'Brand-update',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/common/update.vue')
    },
    {
        path: '/category',
        name: 'Category-listing',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/category/categoryListing.vue')
    },
    {
        path: '/category/create',
        name: 'Category-create',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/common/create.vue')
    },
    {
        path: '/category/update',
        name: 'Category-update',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/common/update.vue')
    },
    {
        path: '/class',
        name: 'Class-listing',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/class/classListing.vue')
    },
    {
        path: '/class/create',
        name: 'Class-create',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/common/create.vue')
    },
    {
        path: '/class/update',
        name: 'Class-update',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/common/update.vue')
    },
    {
        path: '/form',
        name: 'Form-listing',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/form/formListing.vue')
    },
    {
        path: '/form/create',
        name: 'Form-create',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/common/create.vue')
    },
    {
        path: '/form/update',
        name: 'Form-update',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/common/update.vue')
    },
    {
        path: '/moa',
        name: 'MOA-listing',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/moa/moaListing.vue')
    },
    {
        path: '/moa/create',
        name: 'MOA-create',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/common/create.vue')
    },
    {
        path: '/moa/update',
        name: 'MOA-update',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/common/update.vue')
    },
    {
        path: '/printer-proof-status',
        name: 'Printer-proof-listing',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/printerProof/printerProofListing.vue')
    },
    {
        path: '/printer-proof-status/create',
        name: 'Printer-proof-create',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/common/create.vue')
    },
    {
        path: '/printer-proof-status/update',
        name: 'Printer-proof-update',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/common/update.vue')
    },
    {
        path: '/purpose',
        name: 'Purpose-listing',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/purpose/purposeListng.vue')
    },
    {
        path: '/purpose/create',
        name: 'Purpose-create',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/common/create.vue')
    },
    {
        path: '/purpose/update',
        name: 'Purpose-update',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/common/update.vue')
    },
    {
        path: '/query-status',
        name: 'Query-status-listing',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/queryStatus/statusListing.vue')
    },
    {
        path: '/query-status/create',
        name: 'Query-status-create',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/common/create.vue')
    },
    {
        path: '/query-status/update',
        name: 'Query-status-update',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/common/update.vue')
    },
    {
        path: '/registration-status',
        name: 'Registration-status-listing',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/registrationStatus/statusListing.vue')
    },
    {
        path: '/registration-status/create',
        name: 'Registration-status-create',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/common/create.vue')
    },
    {
        path: '/registration-status/update',
        name: 'Registration-status-update',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/common/update.vue')
    },
    {
        path: '/risk-status',
        name: 'Risk-status-listing',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/riskStatus/statusListing.vue')
    },
    {
        path: '/risk-status/create',
        name: 'Risk-status-create',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/common/create.vue')
    },
    {
        path: '/risk-status/update',
        name: 'Risk-status-update',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/common/update.vue')
    },
    {
        path: '/source',
        name: 'Source-listing',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/source/sourceListing.vue')
    },
    {
        path: '/source/create',
        name: 'Source-create',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/common/create.vue')
    },
    {
        path: '/source/update',
        name: 'Source-update',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/common/update.vue')
    },
    {
        path: '/status',
        name: 'Status-listing',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/status/statusListing.vue')
    },
    {
        path: '/status/create',
        name: 'Status-create',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/common/create.vue')
    },
    {
        path: '/status/update',
        name: 'Status-update',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/common/update.vue')
    },
    {
        path: '/type',
        name: 'Type-listing',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/type/typeListing.vue')
    },
    {
        path: '/type/create',
        name: 'Type-create',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/common/create.vue')
    },
    {
        path: '/type/update',
        name: 'Type-update',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/common/update.vue')
    },
    {
        path: '/product',
        name: 'Product-listing',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/product/productListing')
    },
    {
        path: '/product-discountinue',
        name: 'Product-discountinue-listing',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/product/productDiscontinueListing')
    },
    {
        path: '/product/create',
        name: 'Product-create',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/product/productCreate')
    },
    {
        path: '/product/update',
        name: 'Product-update',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/product/productUpdate')
    },
     {
        path: '/product/detail',
        name: 'Product-detail',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/product/productDetail')
    },
    {
        path: '/product-ai',
        name: 'Product-ai-listing',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/productAi/productAiListing')
    },
    {
        path: '/product-ai/create',
        name: 'Product-ai-create',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/productAi/productAiCreate')
    },
    {
        path: '/product-ai/update',
        name: 'Product-ai-update',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/productAi/productAiUpdate')
    },
    {
        path: '/product-label',
        name: 'Product-label-listing',
        meta: {
            authRequired: true,
        },
        // component: () => import('../views/pages/productLabel/labelListing')
        component: () => import('../views/pages/productLabelNew/labelListingNew')
    },
    {
        path: '/product-label/create',
        name: 'Product-label-create',
        meta: {
            authRequired: true,
        },
        // component: () => import('../views/pages/productLabel/labelCreate')
        component: () => import('../views/pages/productLabelNew/labelCreateNew')
    },
    {
        path: '/product-label/update',
        name: 'Product-label-update',
        meta: {
            authRequired: true,
        },
        // component: () => import('../views/pages/productLabel/labelUpdate')
        component: () => import('../views/pages/productLabelNew/labelCreateNew')
    },
    {
        path: '/product-payment',
        name: 'Product-payment-listing',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/productPayment/paymentListing')
    },
    {
        path: '/product-payment/create',
        name: 'Product-payment-create',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/productPayment/paymentCreate')
    },
    {
        path: '/product-payment/update',
        name: 'Product-payment-update',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/productPayment/paymentUpdate')
    },
    {
        path: '/product-printer-proof',
        name: 'Product-printer-proof-listing',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/productPrinterProof/proofListing')
    },
    {
        path: '/product-printer-proof/create',
        name: 'Product-printer-proof-create',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/productPrinterProof/proofCreate')
    },
    {
        path: '/product-printer-proof/update',
        name: 'Product-printer-proof-update',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/productPrinterProof/proofUpdate')
    },
    {
        path: '/product-query',
        name: 'Product-query-listing',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/productQuey/queryListing')
    },
    {
        path: '/product-query/create',
        name: 'Product-query-create',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/productQuey/queryCreate')
    },
    {
        path: '/product-query/update',
        name: 'Product-query-update',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/productQuey/queryUpdate')
    },
    {
        path: '/product-recommendation',
        name: 'Product-recommendation-listing',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/productRecommendation/recommendationListing')
    },
    {
        path: '/product-recommendation/create',
        name: 'Product-recommendation-create',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/productRecommendation/recommendationCreate')
    },
    {
        path: '/product-recommendation/update',
        name: 'Product-recommendation-update',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/productRecommendation/recommendationUpdate')
    },
    {
        path: '/product-cert',
        name: 'Product-cert-listing',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/productCert/certListing')
    },
    {
        path: '/product-cert/create',
        name: 'Product-cert-create',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/productCert/certCreate')
    },
    {
        path: '/product-cert/update',
        name: 'Product-cert-update',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/productCert/certUpdate')
    },
    {
        path: '/product-source',
        name: 'Product-source-listing',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/productSource/sourceListing')
    },
    {
        path: '/product-source/create',
        name: 'Product-source-create',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/productSource/sourceCreate')
    },
    {
        path: '/product-source/update',
        name: 'Product-source-update',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/productSource/sourceUpdate')
    },
    {
        path: '/product-sns',
        name: 'Product-sns-listing',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/productSns/snsListing')
    },
    {
        path: '/product-sns/create',
        name: 'Product-sns-create',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/productSns/snsCreate')
    },
    {
        path: '/product-sns/update',
        name: 'Product-sns-update',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/productSns/snsUpdate')
    },
    {
        path: '/product-halex',
        name: 'Product-halex-listing',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/productHalex/productListing')
    },
    {
        path: '/product-halex/create',
        name: 'Product-halex-create',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/productHalex/productCreate')
    },
    {
        path: '/product-halex/update',
        name: 'Product-halex-update',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/productHalex/productUpdate')
    },
    {
        path: '/product-document',
        name: 'Product-document-listing',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/document/documentListing')
    },
    {
        path: '/product-moa',
        name: 'Product-moa-listing',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/productMoa/moaListing')
    },
    {
        path: '/product-moa/create',
        name: 'Product-moa-create',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/productMoa/moaCreate')
    },
     {
        path: '/product-moa/update',
        name: 'Product-moa-update',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/productMoa/moaUpdate')
    },
]
